import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import images from "../components/images"; 
import imagesFT from "../data/imagesFT.json";

export const Vorstandschaft = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="Vorstand" id="Vorstandschaft">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="Vorstand-bx wow zoomIn">
                        <h2>Vorstandschaft</h2>
                        <p>Hier findest du unsere aktuelle Vorstandschaft. Wer welches Amt bekleidet und seit wann sie Mitglied sind.</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme Vorstand-slider">
                            <div className="item">
                                <h4>1. Vorstand</h4>
                                <img src={images[imagesFT.ersterVorstand]} alt="ersterVorstand" />
                                <h5>Christian Meier<br /> Mitglied seit 2007</h5>
                            </div>
                            <div className="item">
                                <h4>2. Vorstand</h4>
                                <img src={images[imagesFT.zweiterVorstand]} alt="zweiterVorstand" />
                                <h5>Michael Beryle<br /> Mitglied seit 2002</h5>
                            </div>
                            <div className="item">
                                <h4>1. Schriftführer</h4>
                                <img src={images[imagesFT.ersterSchriftfuehrer]} alt="ersterSchriftfuehrer" />
                                <h5>Alexandra Mast<br /> Mitglied seit 1996</h5>
                            </div>
                            <div className="item">
                                <h4>2. Schriftführer</h4>
                                <img src={images[imagesFT.zweiterSchriftfuehrer]} alt="zweiterSchriftfuehrer" />
                                <h5>Lara Karcher<br /> Mitglied seit 2002</h5>
                            </div>
                            <div className="item">
                                <h4>1. Kassierer</h4>
                                <img src={images[imagesFT.ersterKassierer]} alt="ersterKassierer" />
                                <h5>Celina Meier<br /> Mitglied seit 2017</h5>
                            </div>
                            <div className="item">
                                <h4>2. Kassierer</h4>
                                <img src={images[imagesFT.zweiterKassierer]} alt="zweiterKassierer" />
                                <h5>Frank Fellmoser<br /> Mitglied seit 2000</h5>
                            </div>
                            <div className="item">
                                <h4>Zeremonienmeister</h4>
                                <img src={images[imagesFT.zeremonienmeister]} alt="zeremonienmeister" />
                                <h5>Bernd Bäuerle<br /> Mitglied seit 2010</h5>
                            </div>
                            <div className="item">
                                <h4>Beisitzer </h4>
                                <img src={images[imagesFT.ersterBeisitzer]} alt="ersterBeisitzer" />
                                <h5>Sandra Karcher<br /> Mitglied seit 1994</h5>
                            </div>
                            <div className="item">
                                <h4>Beisitzer </h4>
                                <img src={images[imagesFT.zweiterBeisitzer]} alt="zweiterBeisitzer" />
                                <h5>Manuel Huck<br /> Mitglied seit 2006</h5>
                            </div>
                            <div className="item">
                                <h4>Zeugwart </h4>
                                <img src={images[imagesFT.zeugwart]} alt="zeugwart" />
                                <h5>Thomas Scheurer<br /> Mitglied seit 1989</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        
    </section>
  )
}